<template>
    <span>
        <img :style="style" :class="class" :src="'data:image/svg+xml;base64,' + this.svg" />
    </span>
</template>
<style></style>
<script>
    const jdenticon = require('jdenticon')
    const jsSHA = require('jssha')

    jdenticon.config = {
        hues: [119],
        lightness: {
            color: [0.47, 0.67],
            grayscale: [0.28, 0.48]
        },
        saturation: {
            color: 0.10,
            grayscale: 0.02
        },
        backColor: '#6b80342e'
    }

    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            width: {
                type: Number,
                default: 32
            },
            style: {
                type: String,
                default: null
            },
            class: {
                type: String,
                default: null
            }
        },
        data () {
            return {
                svg: null
            }
        },
        ready () {
            this.build()
        },
        methods: {
            build () {
                const sha = new jsSHA('SHA-512', 'TEXT')
                sha.setHMACKey('avatar', 'TEXT')
                sha.update(this.text)
                const hash = sha.getHMAC('HEX')

                this.svg = window.btoa(jdenticon.toSvg(hash, this.width))
            }
        },
        watch: {
            text () {
                this.build()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Avatar.vue?fb462a40